




































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ClaimEnum } from '../../services/ClaimEnum';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { General } from '@/services/General';
import Loaders from '../Utilities/Loaders.vue';
import SearchFilter from '../Utilities/SearchFilter.vue'
import { saveAs } from 'file-saver';
import { DropDownItem } from '@/services/DropDownItem';

interface InputField {
    name: string,
    type: string,
    value: string,
    options?: Array<Option>
}

interface ResultPage {
    listPage: Array<Log>,
    total: number
}

interface Log {
    id: string,
    action: string,
    type: string,
    userName: string,
    message: string,
    stackTrace: string,
    notes: string,
    origin: string,
    timestamp: Date
}

interface LogField {
    key: string,
    label: string,
    sortable: boolean,
    tdClass?: string
}

interface Option {
    value?: number | string
    text: string
}

interface UserIsCreated {
    succeeded: boolean,
    username: string
    message: string
}

@Component({
    components: {
        Loaders,
        SearchFilter
    }
})
export default class AdminWidget extends Vue {
    currentPage: number = 1
    logsList: Array<Log> = []
    totalRows: number = 0
    loading: boolean = false
    filterIsOpen: boolean = false
    datesAreValid: boolean = true
    genericSearch: string = ""
    searchFilterPlaceholder: string = "Generic Search!"
    DTPFilterDateStart: string = ""
    DTPFilterDateEnd: string = ""
    TXTFilterType: string = ""
    TXTFilterAction: string = ""
    TXTFilterUsername: string = ""
    TXTFilterMessage: string = ""
    TXTFilterNotes: string = ""
    TXTFilterStackTrace: string = ""
    TXTFilterOrigin: string = ""
    userToAdd: string = ""
    loadingUsersRolesReports: boolean = false;
    loadingLogsReport: boolean = false
    
    dropDownTypes: Array<Option> = new Array();
    dropDownActions: Array<Option> = new Array();
    
    selectedStartDate: string = null;
    selectedEndDate: string = null;    
    selectedValueType: string = null;
    selectedValueAction: string = null;
    advUsernameFilter: string = null;
    advMessageFilter: string = null;
    advNoteFilter: string = null;
    advOriginFilter: string = null;
    advStackTraceFilter: string = null;
    elmahWith: number= 100;

    emergencyContacts : any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;

    logFields: Array<LogField> = [
        {
            key: 'timeStamp',
            label: 'Timestamp',
            sortable: false
        },
        {
            key: 'type',
            label: 'Type',
            sortable: false
        },
        {
            key: 'action',
            label: 'Action',
            sortable: false
        },
        {
            key: 'userName',
            label: 'Username',
            sortable: false
        },
        {
            key: 'message',
            label: 'Message',
            sortable: false,
            tdClass: 'detail'
        },
        {
            key: 'notes',
            label: 'Notes',
            sortable: false,
            tdClass: 'textViewCol'
        },
        {
            key: 'stackTrace',
            label: 'StackTrace',
            sortable: false,
            tdClass: 'textViewCol'
        },{
            key: 'origin',
            label: 'Origin',
            sortable: false,
            tdClass: 'textViewCol'
        }
    ]

    search(genericSearch: string) {
        if (genericSearch != null) 
            this.genericSearch = genericSearch
        this.viewLog(1)
    }

    checkDateValidity(): void {
        this.datesAreValid = this.selectedStartDate === "" || this.selectedEndDate === "" || this.selectedStartDate <= this.selectedEndDate ? true : false
    }

    toggleFilter() {
        this.filterIsOpen = !this.filterIsOpen
        if (this.filterIsOpen)
            document.getElementById("filter-icon").classList.add("rotate-90-deg")
        else
            document.getElementById("filter-icon").classList.remove("rotate-90-deg")
    }

    async nextPage() {
        this.currentPage++
        await this.viewLog(this.currentPage)
    }

    reset(): void {
        this.selectedStartDate = null;
        this.selectedEndDate = null;
        this.selectedValueType = null;
        this.selectedValueAction = null;
        this.advUsernameFilter = null;
        this.advMessageFilter = null;
        this.advNoteFilter = null;
        this.advOriginFilter = null;
        this.advStackTraceFilter = null;
        this.datesAreValid = true
    }

    async showModal() {
        this.dropDownTypes = await this.getDropDownTypes();
        this.dropDownActions = await this.getDropDownActions();
        this.logsList = []
        this.filterIsOpen = false
        this.reset()
        this.$bvModal.show('log-viewer')
    }

    showModalElmah(): void{
        this.$bvModal.show('elmah-viewer');
        this.elmahWith = 99;
        
    }

    async viewLog(page: number) {
        if (!this.datesAreValid) {
            const errorMessage = "The selected dates are invalid! Change them before submitting the information"
            General.showAlertDanger(errorMessage, this)
        }
        else {
            if (page === 1) {
                this.logsList = []
                this.currentPage = page
            };
            this.loading = true;
            try {
                let resource: AxiosResponse<ResultPage> = await axios.post<ResultPage>(
                    General.GetApiUrl('/api/Admin/GetLogsWithFilters'),
                    {
                        GenericSearch: this.genericSearch,
                        DateStart: this.selectedStartDate,
                        DateEnd: this.selectedEndDate !== ("" || null) ? this.selectedEndDate + " T23:59:59" : "",
                        Type: this.selectedValueType,
                        Action: this.selectedValueAction,
                        Username: this.advUsernameFilter,
                        Message: this.advMessageFilter,
                        Notes: this.advNoteFilter,
                        StackTrace: this.advStackTraceFilter,
                        CurrentPage: page,
                        Origin: this.advOriginFilter,
                        PageSize: 100
                    }, 
                    {
                        withCredentials: true,
                        responseType: 'json'
                    })
                this.logsList = this.logsList.concat(resource.data.listPage)
                this.totalRows = resource.data.total
            } catch (e) {
                this.logsList = []
                this.totalRows = 0
                e = e as AxiosError
                console.log(e.toString())
                General.showAlertDanger(`Status Code ${e.response.status}`, this)
            }
            finally {
                this.loading = false
            }
        }
    }

    
async downloadLogsReport(){
        this.loadingLogsReport = true;
        try {
                let response = await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/Admin/DownloadLogReports'),
                    data: {
                        GenericSearch: this.genericSearch,
                        DateStart: this.selectedStartDate,
                        DateEnd: this.selectedEndDate !== ("" || null) ? this.selectedEndDate + " T23:59:59" : "",
                        Type: this.selectedValueType,
                        Action: this.selectedValueAction,
                        Username: this.advUsernameFilter,
                        Message: this.advMessageFilter,
                        Notes: this.advNoteFilter,
                        StackTrace: this.advStackTraceFilter,
                        Origin: this.advOriginFilter,
                    },
                    withCredentials: true,
                    responseType: 'blob'
                });                    
                let fileName = General.getFileNameFromHeader(response.headers);
               
                saveAs(new Blob([response.data]), fileName);
                
                this.loadingLogsReport=false;
               
            } catch (error) {
                
                this.loadingLogsReport = false;
                General.showAlertDanger(error, this);
            }
    }


    
async downloadUsersRolesReportExcel() {
        this.loadingUsersRolesReports = true;
        try {

            let endPoint = "DownloadUsersRolesReport"

            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/Admin/" + endPoint),
                withCredentials: true,
                responseType: 'blob'
            });
            let fileName = General.getFileNameFromHeader(response.headers);
                            
            saveAs(new Blob([response.data]), fileName);
            this.loadingUsersRolesReports = false;
        } catch (error) {
            this.loadingUsersRolesReports = false;
            General.showAlertDanger(error, this);
        }
    }

    get isAuthorized(): boolean {
        return this.isAuthorizedLog
    }

    get isAuthorizedLog(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanShowLog)
    }
    get isAuthorizedElmahLog(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanViewElmah)
    }

    get elmahLink(): string{
        return General.GetApiUrl('/elmah');

    }

   async mounted() {
        this.currentPage = 1
     
    }

    async getDropDownTypes(): Promise<any>{
        try {            
            let types: DropDownItem = new DropDownItem();
            let typesList: DropDownItem[] = [];
            console.log(typesList)
            let response = await axios.get<any>(
                General.GetApiUrl('/api/Admin/GetLogTypes'), {
                    responseType: "json",
                    withCredentials: true
                }
            );

            if(response.data){
                response.data.forEach(el => {
                    types =  new DropDownItem();
                    types.idDropDownItem = el;
                    types.itemText = el

                    typesList.push(types)
                })
            }
           return General.SetOptionsDropDown(typesList);
        } catch (error) {
            General.HandleError(error, this);
            return null;
        }
    }

    async getDropDownActions(): Promise<Array<any>>{
        try {
            let actions: DropDownItem = new DropDownItem();
            let actionsList: DropDownItem[] = [];

            let response = await axios.get<any>(
                General.GetApiUrl('/api/Admin/GetLogActions'), {
                    responseType: "json",
                    withCredentials: true
                }
            );

            if(response.data){
                response.data.forEach(el => {
                    actions =  new DropDownItem();
                    actions.idDropDownItem = el;
                    actions.itemText = el

                    actionsList.push(actions)
                })
            }
            return General.SetOptionsDropDown(actionsList);  
        } catch (error) {
            General.HandleError(error, this);
            return null;
        }
    }

    formatDate(date){
        if (date==null) return '';
        return General.showDate( date);

    }
}
